// REACT_APP_API_DOMAIN must be supplied at build time (e.g. via
// `env-cmd -f .env.staging` for the staging build, or REACT_APP_API_DOMAIN=...
// set directly on the build command in CI). Production is the safe fallback
// if it's ever missing, so a misconfigured build points at prod (visibly
// wrong) rather than silently pointing at a backend nobody intended.
//
// NOTE: plain `npm run build` always loads .env.production, never
// .env.development - CRA picks the env file by build COMMAND (start vs
// build), not by deploy target. So a staging build that just runs
// `npm run build` will silently fall through to this default. Use
// `npm run build:staging` (env-cmd -f .env.staging) for staging builds,
// or set REACT_APP_API_DOMAIN explicitly on the build command.
const API_DOMAIN = process.env.REACT_APP_API_DOMAIN || "api.firmconnector.com";

// Always visible in the browser console (nothing sensitive - it's just the
// hostname this exact build was compiled with) so a build pointed at the
// wrong backend, like this one, is obvious in 5 seconds instead of requiring
// a Network-tab hunt.
// eslint-disable-next-line no-console
console.info(
  `[env] API_DOMAIN = ${API_DOMAIN}${process.env.REACT_APP_API_DOMAIN ? "" : " (fallback default - REACT_APP_API_DOMAIN was not set at build time)"}`,
);

const API_BASE = `https://${API_DOMAIN}/index.php/`;
const ASSETS_BASE = `https://${API_DOMAIN}/assets/`;
const PROFILE_IMG_BASE = `https://${API_DOMAIN}/`;
const FIRM_IMG_BASE = `https://${API_DOMAIN}/`;

export { API_BASE, ASSETS_BASE, PROFILE_IMG_BASE, FIRM_IMG_BASE };
